import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProjectProvider } from "@/contexts/ProjectContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { GA4RouteTracker } from "@/analytics/GA4RouteTracker";
import { ConsentBanner } from "@/analytics/ConsentBanner";

import LandingPage from "@/pages/LandingPage";
import PricingPage from "@/pages/PricingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardHome from "@/pages/DashboardHome";
import KeywordIntelligence from "@/pages/KeywordIntelligence";
import ArticleGenerator from "@/pages/ArticleGenerator";
import GrowthPlanPage from "@/pages/GrowthPlanPage";
import SalesGrowthDashboard from "@/pages/SalesGrowthDashboard";
import SEOAuditPage from "@/pages/SEOAuditPage";
import AISearchVisibilityPage from "@/pages/AISearchVisibilityPage";
import ContentCalendarPage from "@/pages/ContentCalendarPage";
import BacklinksPage from "@/pages/BacklinksPage";
import ConversionBlocksPage from "@/pages/ConversionBlocksPage";
import InternalLinksPage from "@/pages/InternalLinksPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPanel from "@/pages/AdminPanel";
import TasksPage from "@/pages/TasksPage";
import ReportsPage from "@/pages/ReportsPage";
import BlogPreviewPage from "@/pages/BlogPreviewPage";
import PublicReportPage from "@/pages/PublicReportPage";
import ContentItemDetailPage from "@/pages/ContentItemDetailPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import BillingCancelPage from "@/pages/BillingCancelPage";
import UsagePage from "@/pages/UsagePage";

function App() {
  return (
    <BrowserRouter>
      <GA4RouteTracker />
      <ConsentBanner />
      <AuthProvider>
        <ProjectProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/billing/success" element={<BillingSuccessPage />} />
            <Route path="/billing/cancel" element={<BillingCancelPage />} />
            <Route path="/blog/:id" element={<BlogPreviewPage />} />
            <Route path="/r/:id" element={<PublicReportPage />} />

            <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
            <Route path="/keywords" element={<ProtectedRoute><KeywordIntelligence /></ProtectedRoute>} />
            <Route path="/articles" element={<ProtectedRoute><ArticleGenerator /></ProtectedRoute>} />
            <Route path="/growth-plan" element={<ProtectedRoute><GrowthPlanPage /></ProtectedRoute>} />
            <Route path="/sales-growth" element={<ProtectedRoute><SalesGrowthDashboard /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute><SEOAuditPage /></ProtectedRoute>} />
            <Route path="/ai-visibility" element={<ProtectedRoute><AISearchVisibilityPage /></ProtectedRoute>} />
            <Route path="/content-calendar" element={<ProtectedRoute><ContentCalendarPage /></ProtectedRoute>} />
            <Route path="/content/:id" element={<ProtectedRoute><ContentItemDetailPage /></ProtectedRoute>} />
            <Route path="/backlinks" element={<ProtectedRoute><BacklinksPage /></ProtectedRoute>} />
            <Route path="/conversion-blocks" element={<ProtectedRoute><ConversionBlocksPage /></ProtectedRoute>} />
            <Route path="/internal-links" element={<ProtectedRoute><InternalLinksPage /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute><IntegrationsPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
            <Route path="/usage" element={<ProtectedRoute><UsagePage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
          </Routes>
        </ProjectProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
